<template>
    <div style="padding:30px">
        <div class="my-title">
            收货地址
        </div>
        <!-- 添加新地址 -->
        <div class="add_Adress">
            <el-button
                @click="dialogFormVisible = true"
                type="warning"
                icon="el-icon-plus"
                circle
            ></el-button>
            <span>添加新地址</span>
        </div>

        <!-- 表格  -->
        <div class="draftsTable">
            <el-table
                :data="tableDataList"
                :header-cell-style="{
                    color: '#848484',
                    background: '#f4f4f4',
                    textAlign: 'center'
                }"
                border
                style="width: 100%"
                :cell-style="{ textAlign: 'center' }"
            >
                <el-table-column prop="consignee" label="收货人" width="180">
                </el-table-column>
                <el-table-column prop="province_name" label="地区" width="180">
                </el-table-column>
                <el-table-column prop="name" label="详情地址">
                    <template slot-scope="scope">
                        {{
                            scope.row.province_name +
                                scope.row.city_name +
                                scope.row.area_name +
                                scope.row.address
                        }}
                    </template>
                </el-table-column>

                <el-table-column prop="phone" label="电话"> </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span
                            @click="addressInfo(scope.row.id)"
                            style="cursor:pointer"
                            >编辑</span
                        >
                        |
                        <span
                            @click="delAdress(scope.row.id)"
                            style="cursor:pointer"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
 <!-- 分页 -->
          <div class="shopp_pagination">
            <el-button
              size="small"
              style="width: 80px; height: 30px"
              @click="pervious"
              >上一页</el-button
            >
            <el-pagination
              ref="pageGroup"
              :current-page="currentPage"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              background
              layout="pager"
              :total="total"
            >
            </el-pagination>
            <el-button
              style="width: 80px; height: 30px"
              size="small"
              @click="next"
              >下一页</el-button
            >
          </div>
        <!--添加 弹出框 -->

        <el-dialog  title="添加新地址" :visible.sync="dialogFormVisible">
            <el-form style="width:100%" :model="addressData" label-width="100px" ref="formName">
                <el-form-item label="收货人:">
                    <el-input
                        v-model="addressData.consignee"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="所在地区：">
                    <el-cascader
                        size="large"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleChange"
                    >
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址:">
                    <el-input
                        v-model="addressData.address"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="手机号码：">
                    <el-input
                        v-model="addressData.phone"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="邮编：">
                    <el-input
                        v-model="addressData.postcode"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="地址别名：">
                    <el-input
                        v-model="addressData.alias"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="ResultVisible"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!--编辑 弹出框  -->
        <el-dialog title="编辑收货地址" :visible.sync="EditdialogFormVisible">
            <el-form :model="editAdressData">
                <!-- 收货人 -->
                <el-form-item label="收货人" style="margin-left:18px">
                    <el-input
                        v-model="editAdressData.consignee"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <!-- 所在地区 -->
                <el-form-item label="所在地区:">
                    <!-- 省 -->
                    <el-select
                        placeholder="请选择省"
                        v-model="province"
                        @change="getCity"
                    >
                        <el-option
                            v-for="item in arrAll.provinceData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <!-- 市 -->
                    <el-select
                        placeholder="请选择市"
                        @change="getCounty"
                        v-model="city"
                    >
                        <el-option
                            v-for="item in cityArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <!-- 区 -->
                    <el-select
                        placeholder="请选择区"
                        @change="getaresID"
                        v-model="county"
                    >
                        <el-option
                            v-for="item in countyArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!--详细地址 -->
                <el-form-item label="手机号" style="margin-left:18px">
                    <el-input
                        v-model="editAdressData.phone"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <!--手机号码 -->
                <el-form-item label="详细地址">
                    <el-input
                        v-model="editAdressData.address"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditdialogFormVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="EditResultVisible"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    provinceAndCityData,
    regionData,
    provinceAndCityDataPlus,
    regionDataPlus,
    CodeToText,
    TextToCode
} from "element-china-area-data";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import {
    address,
    addressDel,
    Provinces,
    addressEdit,
    addressInfo
} from "@/api/index.js";
export default {
    data() {
        return {
            //地址对象
            addressData: {
                consignee: "",
                address: "",
                phone: "",
                area_id: "",
                postcode: "",
                alias: ""
            },
            editAdressData: {},
            tableData: [],
            dialogFormVisible: false,
            EditdialogFormVisible: false,
            province: "", // 省份
            city: "", // 市
            county: "", //县/区
            cityArr: [],
            countyArr: [],
            arrAll: [],
            options: regionData,
            selectedOptions: [],
            total: 1,
            currentPage: 1,
            pageSize: 3,
        };
    },
    created() {
        this.getAddress();
        this.getProcinces();
    },
    methods: {
        //省市区
        getProcinces() {
            Provinces(header).then(res => {
                if (res.code != 1) {
                    return;
                }
                console.log(res.data);
                this.arrAll = res.data;
                // .areaData
                // this.cityData = res.data.cityData
                // this.provinceData = res.data.provinceData
            });
        },
        getCity() {
            this.cityArr = [];
            this.city = "";
            this.countyArr = [];
            this.county = "";
            for (var i = 0; i < this.arrAll.cityData.length; i++) {
                for (var j = 0; j < this.arrAll.cityData[i].length; j++) {
                    var obj = this.arrAll.cityData[i][j];
                    if (this.province == obj.pid) {
                        this.cityArr.push(obj);
                    }
                }
            }
        },
        getCounty() {
            this.countyArr = [];
            this.county = "";
            for (var i = 0; i < this.arrAll.areaData.length; i++) {
                for (var j = 0; j < this.arrAll.areaData[i].length; j++) {
                    for (
                        var z = 0;
                        z < this.arrAll.areaData[i][j].length;
                        z++
                    ) {
                        var obj = this.arrAll.areaData[i][j][z];
                        if (this.city == obj.pid) {
                            this.countyArr.push(obj);
                            console.log(obj.value);
                        }
                    }
                }
            }
        },
        getaresID(val) {
            this.addressData.area_id = val;
            this.editAdressData.area_id = val;
        },
        //收货地址列表
        getAddress() {
            address({}, header).then(res => {
                if (res.code == 1) {
                    this.tableData = res.data;
                    console.log(res.data.length);
                    this.total = res.data.length
                }
            });
        },
        //删除地址
        delAdress(id) {
            addressDel({ id: id }, header).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return;
                }
                this.getAddress();
            });
        },
        //添加地址
        ResultVisible() {
            console.log("s");
            console.log(this.addressData);
            addressEdit(this.addressData, header).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.dialogFormVisible = false;
                this.addressData = {};
                this.getAddress();
            });
        },
        //根据id查询编辑地址
        addressInfo(id) {
            this.EditdialogFormVisible = true;
            addressInfo({ id: id }, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.editAdressData = res.data;
                console.log(res.data);
                this.province = res.data.province_name;
                this.city = res.data.city_name;
                this.county = res.data.area_name;
            });
        },
        //编辑提交
        EditResultVisible() {
            addressEdit(this.editAdressData, header).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.EditdialogFormVisible = false;
                this.editAdressData = {};
                this.getAddress();
            });
        },
        handleChange(e) {
            this.addressData.area_id = e[2];
        },
         //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
    },
    computed:{
     tableDataList: function () {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
    }
};
</script>
<style lang="less" scoped>
.shopp_pagination {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.add_Adress {
    float: right;
    padding-right: 43px;
    padding-bottom: 19px;
    display: flex;
    .el-button.is-circle {
        width: 29px;
        height: 30px;
        background: #ff6701;
        position: relative;
        margin-right: 10px;
        /deep/ .el-icon-plus {
            position: absolute;
            top: 7px;
            left: 7px;
        }
    }
    span {
        width: 100px;
        height: 20px;
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #323232;
        line-height: 30px;
    }
}
.el-form-item__label {
    float: none;
    width: 100%;
}
.el-input {
    width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/harvestAddress.vue